<script>
    import ExactSearch from '@/mixins/exactSearch'
    export default {
        mixins: [ExactSearch],
        props:{
            tenementInfoObj: Object,
        },
        beforeCreate () {
            this.fields = ['appName','appCode','tenementCode']
        },
        methods: {
            getFieldTpls (model) {
                model.appName = _.trim(model.appName)
                model.appCode = _.trim(model.appCode)
                const tpls = {
                    'appName': <el-form-item label={this.$t('language.5o6vnf9rx200')}><el-input v-model={model.appName} maxlength={30} clearable/></el-form-item>,
                    'appCode': <el-form-item title={this.$t('language.5o6u3wttipk0')} label={this.$t('language.5o6u3wttipk0')}><el-input v-model={model.appCode} maxlength={30} clearable/></el-form-item>,
            }
                return tpls
            },

        /*   handleSearch () {
                let query = this.toEnd()
               // console.log(111,query)
                this.updateState({ query, pageIndex: 1 })
                this.queryList()
            },
            */
        },

    }
</script>
